import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7ListResponse, Cin7Location } from "@/api/dtos";
import type { Location } from "./_models/Location";
import { toLocationFromCin7Location } from "./_transformers/toLocationFromCin7Location";

type LocationListResponse = Cin7ListResponse<"LocationList", Cin7Location>;

const PAGE_LIMIT = 500;

/** Cin7 locations, first page of up to 500 (GET /cin7/location-list via the backend Cin7 proxy). */
export const getLocationListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLocationList: builder.query<Location[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<LocationListResponse>(
            `${backendBase()}/cin7/location-list`,
            {
              params: { Page: 1, Limit: PAGE_LIMIT },
              headers: { Accept: "application/json" },
            },
          );
          const locations = res.data.LocationList.map((x) => toLocationFromCin7Location(x));
          return { data: locations };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getLocationList = getLocationListApi.endpoints.getLocationList;
